export default function Products() {
  const products = [
    {
      name: 'SecureVPN',
      gradient: 'from-blue-500 to-cyan-400',
      icon: 'ri-shield-check-line',
      features: [
        'Military-grade encryption for complete privacy',
        'Global server network across 50+ countries',
        'Zero-log policy ensuring data protection'
      ],
      image: 'https://public.readdy.ai/ai/img_res/e9ec6ef340831fb317b1122ba3028ff1.jpg'
    },
    {
      name: 'SmartCleaner',
      gradient: 'from-pink-500 to-orange-400',
      icon: 'ri-brush-line',
      features: [
        'Intelligent junk file removal and cleanup',
        'Memory optimization for peak performance',
        'Battery life enhancement technology'
      ],
      image: 'https://readdy.ai/api/search-image?query=circular%20progress%20visualization%20showing%20storage%20optimization%20on%20coral%20pink%20to%20orange%20gradient%20background%20modern%20minimalist%20design%20clean%20tech%20aesthetic%20digital%20performance%20concept%20simple%20geometric%20shapes&width=600&height=400&seq=cleaner-visual&orientation=landscape'
    }
  ];

  return (
    <section id="products" className="bg-[#F5F7FA] py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-[#0A1628] mb-4">Our Solutions</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Powerful iOS applications designed to enhance security and optimize device performance
          </p>
        </div>

        <div className="grid grid-cols-2 gap-16" data-product-shop>
          {products.map((product, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* Top Section with Gradient */}
              <div className={`relative h-80 bg-gradient-to-br ${product.gradient} flex items-center justify-center`}>
                <div className="absolute inset-0 opacity-30">
                  <img 
                    src={product.image} 
                    alt={`${product.name} visualization`}
                    title={`${product.name} - iOS Application`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="relative w-20 h-20 flex items-center justify-center">
                  <i className={`${product.icon} text-white text-7xl`}></i>
                </div>
              </div>

              {/* Bottom Section with Details */}
              <div className="p-10">
                <h3 className="text-3xl font-bold text-[#0A1628] mb-6">{product.name}</h3>
                <ul className="space-y-4">
                  {product.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-blue-500 text-xl flex-shrink-0 mt-0.5"></i>
                      <span className="text-gray-700 leading-relaxed">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
